import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { useGoustoAnytimeMenuVariant } from 'routes/Menu/experiments/GoustoAnytime/useGoustoAnytimeMenuVariant'
import { getBasketOrderId } from 'selectors/basket'
import { getUserOrders, getUserSubscriptionState } from 'selectors/user'

const GOUSTO_ANYTIME_FLAG = 'tomatoes_ofx_webclient_gousto_anytime'

type UserOrder = { orderType?: string }
type UserOrdersImmutable = { toJS: () => Record<string, UserOrder> }

export const useShowGoustoAnytimeOrderConfirmationBanner = (): boolean => {
  const [decision] = useDecision(GOUSTO_ANYTIME_FLAG)
  const orderId = useSelector(getBasketOrderId) as string | '' | undefined
  const userOrders = useSelector(getUserOrders) as UserOrdersImmutable
  const subscriptionState = useSelector(getUserSubscriptionState) as string | undefined
  const isInMenuExperienceVariant = useGoustoAnytimeMenuVariant()

  const isTransactional = !!orderId && userOrders.toJS()[orderId]?.orderType === 'transactional'
  const hasActiveSubscription = subscriptionState === 'active'

  return decision.enabled && isTransactional && isInMenuExperienceVariant && !hasActiveSubscription
}
